import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  AutoRedemptionSettingTypes,
  CreateAutoRedemptionSettingFail,
  CreateAutoRedemptionSettingSuccess,
  DeleteAutoRedemptionSettingFail,
  SubmitAutoRedemptionSettingForm,
} from '@features/auto-redemption-settings/store/actions/auto-redemption-settings.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { CheckoutErrorDialogComponent } from '@rd/shared-legacy/components/checkout-error-dialog/checkout-error-dialog.component';
import { AutoRedemptionSettingType } from '@rd/types/auto-redemption-setting.type';
import { tap } from 'rxjs/operators';

@Injectable()
export class AnzBizAutoRedemptionEffects {
  constructor(
    private actions$: Actions,
    private dialogService: DialogService,
    private router: Router,
  ) {}

  submitAutoRedemptionSettingForm$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AutoRedemptionSettingTypes.SUBMIT_AUTO_REDEMPTION_SETTING_FORM),
        tap((action: SubmitAutoRedemptionSettingForm) => {
          switch (action.payload.type) {
            case AutoRedemptionSettingType.PointsTransfer: {
              const isEverydaySpend = action.isEverydaySpend;

              this.router.navigateByUrl(
                isEverydaySpend
                  ? `/everyday_rewards/checkout/auto-redemption/${action.payload.product_id}/review`
                  : `/transfer/checkout/auto-redemption/${action.payload.product_id}/review`,
              );
              break;
            }
            case AutoRedemptionSettingType.Cash: {
              this.router.navigateByUrl(
                `/redeem_cash/checkout/auto-redemption/${action.payload.product_id}/review`,
              );
              break;
            }
            case AutoRedemptionSettingType.PhysicalGiftCard:
            case AutoRedemptionSettingType.DigitalGiftCard: {
              this.router.navigateByUrl(
                `/gift_card/checkout/auto-redemption/${action.payload.product_id}/review`,
              );
              break;
            }
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  createAutoRedemptionSettingSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          AutoRedemptionSettingTypes.CREATE_AUTO_REDEMPTION_SETTING_SUCCESS,
        ),
        tap((action: CreateAutoRedemptionSettingSuccess) => {
          switch (action.payload.type) {
            case AutoRedemptionSettingType.PointsTransfer: {
              const isEverydaySpend = action.isEverydaySpend;

              this.router.navigateByUrl(
                isEverydaySpend
                  ? `/everyday_rewards/checkout/auto-redemption/success/${action.payload.id}`
                  : `/transfer/checkout/auto-redemption/success/${action.payload.id}`,
              );
              break;
            }

            case AutoRedemptionSettingType.Cash: {
              this.router.navigateByUrl(
                '/redeem_cash/checkout/auto-redemption/success/' +
                  action.payload.id,
              );
              break;
            }
            case AutoRedemptionSettingType.PhysicalGiftCard:
            case AutoRedemptionSettingType.DigitalGiftCard: {
              this.router.navigateByUrl(
                `/gift_card/checkout/auto-redemption/success/${action.payload.id}`,
              );
              break;
            }
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  createAutoRedemptionSettingFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          AutoRedemptionSettingTypes.CREATE_AUTO_REDEMPTION_SETTING_FAIL,
          AutoRedemptionSettingTypes.UPDATE_AUTO_REDEMPTION_SETTING_FAIL,
        ),
        tap((action: CreateAutoRedemptionSettingFail) => {
          this.dialogService.open(CheckoutErrorDialogComponent, {
            data: {
              error: action.payload,
              iconName: 'warning',
            },
            id: 'rd-shared-checkout-error-dialog',
            screenMode: 'center-md',
          });
        }),
      ),
    {
      dispatch: false,
    },
  );

  deleteAutoRedemptionSettingFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AutoRedemptionSettingTypes.DELETE_AUTO_REDEMPTION_SETTING_FAIL),
        tap((action: DeleteAutoRedemptionSettingFail) =>
          this.dialogService.open(CheckoutErrorDialogComponent, {
            id: 'rd-auto-redemption-setting-error-dialog',
            screenMode: 'center-md',
            data: {
              error: action.payload,
              iconName: 'unexpected-error',
            },
          }),
        ),
      ),
    {
      dispatch: false,
    },
  );
}
